// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WeatherProductCard {
}
.WeatherProductCard h1 {
  color: black !important;
  font-size: 1.5rem;
  text-align: center;
}
.WeatherProductCard .btn_container {
  width: 100%;
  overflow-y: auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 68vh; */
  gap: 2.3rem;
  border-radius: 2rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background-color: #f5f5f5;
}
.WeatherTempProductCard {
  width: 100%;
  overflow-y: hidden;
  padding: 1.5rem;
  border-radius: 2rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background-color: #fff;
}

.WeatherProductCard .btn_container div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.WeatherProductCard .btn_container div::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.WeatherProductCard .btn_container div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}
.WeatherProductCard .btn_container button {
  border: none;
  background-color: transparent;
  box-shadow: none;
}
.WeatherProductCard .btn_container button:focus {
  box-shadow: #06bea7 0 4px 15px -5px;
  color: #06bea7;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/WeatherProductCard.css"],"names":[],"mappings":"AAAA;AACA;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iDAAiD;EACjD,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB","sourcesContent":[".WeatherProductCard {\n}\n.WeatherProductCard h1 {\n  color: black !important;\n  font-size: 1.5rem;\n  text-align: center;\n}\n.WeatherProductCard .btn_container {\n  width: 100%;\n  overflow-y: auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  /* height: 68vh; */\n  gap: 2.3rem;\n  border-radius: 2rem;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  background-color: #f5f5f5;\n}\n.WeatherTempProductCard {\n  width: 100%;\n  overflow-y: hidden;\n  padding: 1.5rem;\n  border-radius: 2rem;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  background-color: #fff;\n}\n\n.WeatherProductCard .btn_container div::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.WeatherProductCard .btn_container div::-webkit-scrollbar {\n  width: 12px;\n  background-color: #f5f5f5;\n}\n\n.WeatherProductCard .btn_container div::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #555;\n}\n.WeatherProductCard .btn_container button {\n  border: none;\n  background-color: transparent;\n  box-shadow: none;\n}\n.WeatherProductCard .btn_container button:focus {\n  box-shadow: #06bea7 0 4px 15px -5px;\n  color: #06bea7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
